import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

import {HttpOptionsModel} from '@myModels/Shared/http-options';
import {CustomHttpService} from '@myServices/custom-http.service';
import {catchError, map} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class GameService {

    constructor(private customHttpService: CustomHttpService) {
    }

    private currentGames = new Subject();
    groupIdSource = new BehaviorSubject<string>('');

    getAllGames() {
        const httpOptions = new HttpOptionsModel('/all-games', null, false, true);
        return this.customHttpService.post(httpOptions);
    }

    getGameInfo(gameId, isMobile, returnUrl, language) {
        const postData = {
            game_id: gameId,
            mobile: isMobile,
            return_url: returnUrl,
            language: language,
            platform: isMobile ? 'mobile' : 'desktop'
        };
        const httpOptions = new HttpOptionsModel('/game', postData, false, true);
        return this.customHttpService.post(httpOptions).pipe(
            catchError((error) => {
                if (error.error && error.error.messages) {
                    throw new Error(error.error.messages[0]);
                }
                throw new Error('UNEXPECTED_ERROR');
            }), map((res: any) => {
                if (!res.status) {
                    throw new Error(res.messages[0]);
                }
                return res;
            })
        );
    }

    getCurrentGames() {
        return this.currentGames.asObservable();
    }

    onCurrentGamesChange(currentGames) {
        this.currentGames.next(currentGames);
    }

    getListGames(postData) {
        const httpOptions = new HttpOptionsModel('/list-games', postData, false, true);
        return this.customHttpService.post(httpOptions).pipe(
            catchError((error) => {
                if (error.error.messages) {
                    throw new Error(error.error.messages[0]);
                }
                throw new Error('UNEXPECTED_ERROR');
            }), map((res: any) => {
                if (!res.status) {
                    throw new Error(res.messages[0]);
                }
                return res;
            })
        );
    }

    getSiteGames() {
        const postData = {
            groupType: 0
        };
        return this.getListGames(postData);
    }

    searchGamesByName(name, type = 0) {
        const postData = {
            groupType: type,
            search: name
        };
        return this.getListGames(postData);
    }

    getLiveCasinoGames(data?: any) {
        const postData = {
            groupType: 2
        };

        return this.getListGames(postData);
    }

    getVirtualSportsGames(search?: string) {

        const golderRaceProviderId = 133;
        const postData: any = {
            groupType: 3,
            provider: golderRaceProviderId
        };

        if (search) {
            postData.search = search;
        }

        return this.getListGames(postData);
    }


    onLiveCasinoGamesChange(currentGames) {
        this.currentGames.next(currentGames);
    }

    getProviderLiveCasinoGames(provider, searchText?: string) {
        const postData: any = {
            groupType: 2,
            provider: provider
        };
        if (searchText) {
            postData.search = searchText;
        }
        return this.getListGames(postData);
    }

    getFeaturedGames() {
        const httpOptions = new HttpOptionsModel('/featured-games', null, false, true);
        return this.customHttpService.post(httpOptions).pipe(
            catchError((error) => {
                if (error.error.messages) {
                    throw new Error(error.error.messages[0]);
                }
                throw new Error('UNEXPECTED_ERROR');
            }), map((res: any) => {
                if (!res.status) {
                    throw new Error(res.messages[0]);
                }
                return res;
            })
        );
    }

    getGoldenRaceLobby(data) {
        const httpOptions = new HttpOptionsModel('/golden-race-game', data, true, true);
        return this.customHttpService.post(httpOptions);
    }

    getMicroGamingBalance() {
        const postData = {
            action: 'balance'
        };
        const httpOptions = new HttpOptionsModel('/mgwallet', postData, true, true);
        return this.customHttpService.post(httpOptions);
    }

    setMicroGamingAction(data) {
        const httpOptions = new HttpOptionsModel('/mgwallet', data, true, true);
        return this.customHttpService.post(httpOptions);
    }

    getProductsByType(data) {
        const httpOptions = new HttpOptionsModel('/game/types', data, true, true);
        return this.customHttpService.post(httpOptions).pipe(
            catchError((error) => {
                if (error.error.messages) {
                    throw new Error(error.error.messages[0]);
                }
                throw new Error('UNEXPECTED_ERROR');
            }), map((res: any) => {
                if (!res.status) {
                    throw new Error(res.messages[0]);
                }
                return res;
            })
        );
    }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/game.service.ts